import React from 'react';
import { Text } from '../../../../models/Utilities/Text';
import TextBoxWithCtx from '../../../common/inputElements/TextBoxWithCtx';
import MessageParagraph from './MessageParagraph';

interface IProps {
  isActive: boolean;
  message: Text;
  clickHandler: () => void;
  removeHandler: () => void;
}
const MessageItem: React.FC<IProps> = ({
  isActive,
  clickHandler,
  removeHandler,
  message,
}) => {
  const handleMessageChange = (newContent: string) => {
    message!.value = newContent;
  };

  return (
    <div className='message-item' id={message.id} onClick={clickHandler}>
      {isActive ? (
        <TextBoxWithCtx
          autofocus
          value={message!.value ?? ''}
          saveHandler={handleMessageChange}
          placeholder='Enter a message'
          multiline
        />
      ) : (
        <MessageParagraph
          message={message}
          placeholder='Enter a message'
          removeHandler={removeHandler}
        />
      )}
      <hr />
    </div>
  );
};

export default React.memo(
  MessageItem,
  (prevProps, nextProps) => prevProps.isActive === nextProps.isActive
);
